import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import "./IndividualCompetition.css";
import GuestNav from '../Navbars/GuestNav';
import Footer from "../Footer";
import { UserContext } from '../UserContext';

const IndividualCompetition = () => {
  const navigate = useNavigate();
  const { setUserRole } = useContext(UserContext);

  const onLogin = (usertype) => {
    const userRole = usertype === 'Student' ? "Student" : 
                    usertype === 'Teacher' ? "Teacher" : 
                    usertype === 'Admin' ? "Admin" : "guest";
    setUserRole(userRole);
  };

  const handleViewResults = () => {
    navigate('/PolymatchResults');
  };

  return (
    <>
      <GuestNav onLogin={onLogin} />
      <div className="individual-competition-container">
        <button 
          className="view-results-button"
          onClick={handleViewResults}
        >
          <span>Click Here To View Result</span>
        </button>
      </div>
      <Footer />
    </>
  );
};

export default IndividualCompetition;
